import * as ko from "knockout";
import {NewsWidgetViewModel, NewsWidgetViewModelParams} from "./NewsWidgetViewModel";

const component: KnockoutComponentTypes.Config = {
    viewModel: (params: NewsWidgetViewModelParams) => new NewsWidgetViewModel(params),
    template: <string>require('./sidebar-news-item.html')
};

export default component;

if (!ko.components.isRegistered('sidebar-news-item')) {
    ko.components.register('sidebar-news-item', component)
}